// OTP delivery — Option B (server-side generation + delivery).
//
// The plaintext code is minted and delivered by the `send-otp` Edge Function
// (service-role → request_otp → Twilio SMS). The client NEVER generates the code
// and, in production, NEVER receives it. sendOtp() only kicks off the send with
// the invite token (which authorizes it) and returns whatever the function
// returns — a code is present ONLY when the server dev-echo flag (OTP_DEV_ECHO)
// is on, so the dev banner keeps working in staging without a client flag.
//
// NOTE: the send/dev distinction now lives SERVER-SIDE (OTP_DEV_ECHO + Twilio
// secrets on the Edge Function). REACT_APP_OTP_MODE is retained for reference/
// copy only; it no longer gates delivery (that would reintroduce a client-side
// switch over a server security boundary).
import { supabaseClient } from '../../../shared/utils/supabaseClient';

export const OTP_MODE = (process.env.REACT_APP_OTP_MODE || 'dev').toLowerCase();

/**
 * Ask the server to send the member's OTP.
 * @param {{ inviteToken: string }} args
 * @returns {Promise<{ delivered: boolean, code: string|null }>} code is non-null
 *          only when the server echoes it (staging); always null in production.
 */
export const sendOtp = async ({ inviteToken }) => {
  const { data, error } = await supabaseClient.functions.invoke('send-otp', {
    body: { inviteToken },
  });
  if (error) throw new Error(error.message || 'Could not send your code.');
  if (data?.error) throw new Error(data.error);
  return { delivered: true, code: data?.code ?? null };
};
